export const user = {
	GET_USER: "user/get",
	GET_PROFILE: "user/profile",
	GET_DETAIL_USER: "user/detail",
}

export default user
